"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4668],{

/***/ 70650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ common_ArticleListItem; }
});

// UNUSED EXPORTS: ArticleKeywordWrapper

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/styles/useTheme.js
var useTheme = __webpack_require__(62097);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./components/common/A/index.js
var A = __webpack_require__(79592);
// EXTERNAL MODULE: ./components/common/NowrapDiv/index.js
var NowrapDiv = __webpack_require__(2925);
// EXTERNAL MODULE: ./components/common/TagButton/index.js
var TagButton = __webpack_require__(25133);
// EXTERNAL MODULE: ./components/common/SVGElements/Pen.js
var Pen = __webpack_require__(79193);
// EXTERNAL MODULE: ./components/common/SVGElements/Eye.js
var Eye = __webpack_require__(23183);
// EXTERNAL MODULE: ./components/common/VenderLink/index.js
var VenderLink = __webpack_require__(90879);
// EXTERNAL MODULE: ./utils/request.js
var request = __webpack_require__(72673);
;// CONCATENATED MODULE: ./utils/api/general/setArticleClicked.js

const setArticleClicked = (articleId)=>{
    return (0,request/* safeAwait */.Ev)((0,request/* lsPut */.OL)("/articles/".concat(articleId, "/clicks")));
};

;// CONCATENATED MODULE: ./components/common/ArticleListItem/index.js

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // 子元素保持原本的寬度，不被壓縮\n  & > * {\n    flex-shrink: 0;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-top: 75%;\n  width: 120px;\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 12px;\n  background: url('/img/img_headshot_default.png');\n  background-size: 100%;\n  background-position: center;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  display: none;\n  ",
        "\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}












const ArticleKeywordWrapper = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject());
const ImgRect = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1(), (param)=>{
    let { theme  } = param;
    return "\n    ".concat(theme.breakpoints.up("lg"), " {\n      width: 196px;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      width: 240px;\n    }\n  ");
});
const Absolute = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
const Img = emotion_styled_browser_esm/* default.img */.Z.img(_templateObject3());
const ArticleSummary = (0,emotion_styled_browser_esm/* default */.Z)(Typography/* default */.Z)(_templateObject4(), (param)=>{
    let { theme , $usedInVenderPage  } = param;
    return "\n    ".concat(theme.breakpoints.up($usedInVenderPage ? "xs" : "md"), " {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n    }\n    ").concat(theme.breakpoints.up("xl"), " {\n      -webkit-line-clamp: 3;\n    }\n  ");
});
const ArticleListItem = (param)=>{
    let { article , usedInVenderPage  } = param;
    var _article_vender, _article_vender_introductionInfo, _article_keywords;
    const theme = (0,useTheme/* default */.Z)();
    const isMedium = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("md"));
    const isLarge = (0,useMediaQuery/* default */.Z)(theme.breakpoints.up("lg"));
    const image = (article === null || article === void 0 ? void 0 : article.mediumImage) || (article === null || article === void 0 ? void 0 : article.image);
    const url = "/article/".concat(article === null || article === void 0 ? void 0 : article.urlId);
    var _article_publicViews;
    const articleViews = (_article_publicViews = article === null || article === void 0 ? void 0 : article.publicViews) !== null && _article_publicViews !== void 0 ? _article_publicViews : 0;
    const handleArticleClick = (event)=>{
        var _event_target, _event_target_closest;
        if (usedInVenderPage || !(article === null || article === void 0 ? void 0 : article._id)) return;
        // 避免把點擊作者/標籤誤算成點擊文章
        const clickedLink = (_event_target_closest = (_event_target = event.target).closest) === null || _event_target_closest === void 0 ? void 0 : _event_target_closest.call(_event_target, "a");
        if (clickedLink && clickedLink !== event.currentTarget) return;
        setArticleClicked(article._id);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
        href: url,
        $origin: true,
        target: "_blank",
        onClick: handleArticleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            display: "flex",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImgRect, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Absolute, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Img, {
                                src: image === null || image === void 0 ? void 0 : image.url
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    ml: {
                        xs: 4,
                        xl: 5,
                        xxl: 6
                    },
                    flex: 1,
                    minWidth: 0,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                typography: {
                                    xs: "titleLarge",
                                    lg: "headlineSmall",
                                    xxl: "headlineMedium"
                                }
                            },
                            color: "textPrimary",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                $lines: 2,
                                children: article === null || article === void 0 ? void 0 : article.title
                            })
                        }),
                        !!(article === null || article === void 0 ? void 0 : article.summary) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSummary, {
                            sx: {
                                typography: {
                                    xs: "paraBodySmall",
                                    xl: "paraBodyMedium"
                                }
                            },
                            color: "textSecondary",
                            $usedInVenderPage: usedInVenderPage,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mt: 1,
                                children: article === null || article === void 0 ? void 0 : article.summary
                            })
                        }),
                        !(usedInVenderPage && !isLarge) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagButton/* OneLineGrid */.$, {
                            container: true,
                            spacing: 4,
                            ml: 0,
                            $height: isMedium ? "auto" : "35px",
                            $width: "100%",
                            mt: 3,
                            flexWrap: "nowrap",
                            children: [
                                !usedInVenderPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                    display: "inline-flex",
                                    alignItems: "center",
                                    mb: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            mr: 4,
                                            display: "flex",
                                            flexWrap: "nowrap",
                                            alignItems: "center",
                                            children: (article === null || article === void 0 ? void 0 : (_article_vender = article.vender) === null || _article_vender === void 0 ? void 0 : (_article_vender_introductionInfo = _article_vender.introductionInfo) === null || _article_vender_introductionInfo === void 0 ? void 0 : _article_vender_introductionInfo.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(VenderLink/* default */.Z, {
                                                vender: article === null || article === void 0 ? void 0 : article.vender,
                                                width: isMedium ? "16px" : "20px",
                                                height: isMedium ? "16px" : "20px"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                display: "flex",
                                                alignItems: "center",
                                                flexWrap: "nowrap",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pen/* PenSVG */.m, {
                                                        width: isMedium ? "16px" : "20px",
                                                        height: isMedium ? "16px" : "20px",
                                                        $color: "text.disabled"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        ml: 1.5,
                                                        color: "text.disabled",
                                                        sx: {
                                                            typography: {
                                                                xs: "bodyXs",
                                                                md: "bodySmall"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                            children: article === null || article === void 0 ? void 0 : article.byline
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            mr: 4,
                                            display: "flex",
                                            alignItems: "center",
                                            flexWrap: "nowrap",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Eye/* EyeSVG */.P, {
                                                    width: isMedium ? "16px" : "20px",
                                                    height: isMedium ? "16px" : "20px",
                                                    $color: "text.disabled"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    ml: 1.5,
                                                    color: "text.disabled",
                                                    sx: {
                                                        typography: {
                                                            xs: "bodyXs",
                                                            md: "bodySmall"
                                                        }
                                                    },
                                                    children: articleViews
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !!(article === null || article === void 0 ? void 0 : (_article_keywords = article.keywords) === null || _article_keywords === void 0 ? void 0 : _article_keywords.length) && isLarge && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleKeywordWrapper, {
                                    children: article.keywords.map((keyword, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: "inline-block",
                                            mr: 2,
                                            mb: 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagButton/* default */.Z, {
                                                href: "/article/tag/".concat(keyword.urlId),
                                                size: "sm",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NowrapDiv/* default */.Z, {
                                                    children: keyword.name
                                                })
                                            })
                                        }, index))
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_ArticleListItem = (ArticleListItem);


/***/ }),

/***/ 79193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ PenSVG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54806);


const PenSVG = (props)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SVG__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("g", {
            className: "pen-tool",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                d: "M2.235 1.028a1 1 0 00-1.207 1.207l3.5 14.5a1 1 0 00.776.746l5.765 1.153a1 1 0 00.224 1.073l3 3a1 1 0 001.414 0l7-7a1 1 0 000-1.414l-3-3a1 1 0 00-1.073-.224L17.48 5.304a1 1 0 00-.746-.776l-14.5-3.5zm11.467 17.685l.005-.006 5-5 .006-.005.287-.288L20.586 15 15 20.586 13.414 19l.288-.287zm3.213-6.042l-1.27-6.349L5.22 3.806l4.487 4.486a3 3 0 11-1.414 1.414L3.805 5.22l2.516 10.425 6.35 1.27 4.242-4.244zM10 11a1 1 0 112 0 1 1 0 01-2 0z",
                className: "Union",
                clipRule: "evenodd"
            })
        })
    });
};


/***/ }),

/***/ 25133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ OneLineGrid; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75084);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79072);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29630);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79592);

function _templateObject() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: ",
        ";\n  width: ",
        ";\n  overflow-y: hidden;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}






const OneLineGrid = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_templateObject(), (param)=>{
    let { $height  } = param;
    return $height || "72px";
}, (param)=>{
    let { $width  } = param;
    return $width;
});
const StyledButton = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_templateObject1(), (param)=>{
    let { theme , size , shape  } = param;
    return "\n    border-radius: 25px;\n    font-size: 14px;\n    color: ".concat(theme.palette.text.minus2, ";\n    background: ").concat(theme.palette.grey.third, ";\n    padding: ").concat({
        sm: "10px 12px",
        md: "10px 16px",
        lg: "12px 20px",
        xl: "12px 20px"
    }[size], ";\n    border-radius: ").concat({
        round: "20px",
        rectangle: "6px"
    }[shape], "\n\n    &:hover {\n      background-color: ").concat(theme.palette.primary.bgPlus1, ";\n      box-shadow: none; // shadow override worked here only in ios browser\n    }\n    &:active {\n      background-color: ").concat(theme.palette.primary.main, ";\n      color: #ffffff;\n    }\n  ");
});
const TagButton = (param)=>{
    let { href , children , shape ="round" , size ="md" , ...rest } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: href || "",
        $origin: true,
        ...rest,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledButton, {
            variant: "contained",
            color: "grey",
            shape: shape,
            size: size,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                sx: {
                    typography: {
                        sm: "bodyXs",
                        md: "bodySmall",
                        lg: "bodyMedium",
                        xl: "bodyLarge"
                    }[size]
                },
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TagButton);


/***/ }),

/***/ 90879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var components_common_SVGElements__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79193);
/* harmony import */ var components_common_A__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79592);
/* harmony import */ var components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2925);






const VenderLink = (param)=>{
    let { vender , ...props } = param;
    if (!vender) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_A__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        href: "/vender/".concat(vender === null || vender === void 0 ? void 0 : vender.urlId),
        $color: "text.minus2",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_SVGElements__WEBPACK_IMPORTED_MODULE_4__/* .PenSVG */ .m, {
                    $color: "text.disabled",
                    ...props
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Typography__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    ml: 1.5,
                    color: "text.disabled",
                    sx: {
                        typography: {
                            xs: "bodyXs",
                            md: "bodySmall"
                        }
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_NowrapDiv__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        children: vender === null || vender === void 0 ? void 0 : vender.shortname
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (VenderLink);


/***/ }),

/***/ 4668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61953);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79072);
/* harmony import */ var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58533);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27961);
/* harmony import */ var utils_api_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68138);
/* harmony import */ var components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70650);
/* harmony import */ var utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27582);










const Articles = (param)=>{
    let { venderId , containerId , venderName  } = param;
    const { data , size , setSize  } = (0,utils_api_hooks__WEBPACK_IMPORTED_MODULE_5__/* .useInfiniteArticles */ .g)(()=>({
            venderId
        }));
    const articles = (0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(data);
    const onLoadMore = ()=>setSize(size + 1);
    const displayedArticles = articles.slice(0, 4);
    const handleArticleClick = (article)=>{
        if (!article) return;
        utils_hooks_analytics__WEBPACK_IMPORTED_MODULE_7__/* .GtmAgent.directSendToGTM */ .b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_article",
            living_click_name: article === null || article === void 0 ? void 0 : article.title,
            living_click_location: "廠商頁",
            living_vender: venderName,
            living_click_article_id: article === null || article === void 0 ? void 0 : article._id
        });
    };
    return(// 目前不需滾動功能先註解掉
    // <InfiniteScroll
    //   dataLength={articles?.length || 0}
    //   hasMore={true}
    //   next={onLoadMore}
    //   scrollableTarget={containerId}
    // >
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
        container: true,
        spacing: {
            xs: 6,
            lg: 8
        },
        children: displayedArticles === null || displayedArticles === void 0 ? void 0 : displayedArticles.map((article)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                item: true,
                xs: 12,
                lg: 6,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        height: 350,
                        offset: 350,
                        scrollContainer: "#".concat(containerId),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            onClick: ()=>handleArticleClick(article),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                article: article,
                                usedInVenderPage: true
                            }, article._id)
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("noscript", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                children: ".lazyload-placeholder { display: none; }"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                onClick: ()=>handleArticleClick(article),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_common_ArticleListItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                    article: article,
                                    usedInVenderPage: true
                                }, article._id)
                            })
                        ]
                    })
                ]
            }, article._id))
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Articles);


/***/ }),

/***/ 68138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useInfiniteArticles; }
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86700);


const useInfiniteArticles = (props, swrOptions)=>{
    const getArticlesKey = (opts)=>(pageIndex, previousPageData)=>{
            const propsObject = typeof opts === "function" ? opts() : opts;
            if (propsObject === null) {
                return null;
            }
            if (previousPageData && !previousPageData.length) {
                return null;
            }
            const params = {
                ...propsObject,
                skip: pageIndex * (propsObject.limit || 20),
                limit: propsObject.limit || 20
            };
            return "/articles?".concat((0,qs__WEBPACK_IMPORTED_MODULE_0__.stringify)(params));
        };
    const { data , ...rest } = (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_1__/* .useCustomSWRInfinite */ .KU)(getArticlesKey(props), swrOptions);
    // data會無預期出現數字，不確定為什麼，
    // 先避免直接回傳錯誤的資料類型
    return {
        data: typeof data === "number" ? [] : data,
        ...rest
    };
};


/***/ })

}]);